import { UserSelectors, Customer } from '@next/core-lib/user';
import { createSelector, createFeatureSelector } from '@ngrx/store';

import { getCropYear } from 'src/app/store/selectors';

import { FertilizationLegalStandardState } from '../fertilization-legal-standards.models';

export const selectLegalStandardState = createFeatureSelector<FertilizationLegalStandardState>(
  'fertilizationLegalStandard',
);

export const selectFertilizationLegalStandards = createSelector(
  selectLegalStandardState,
  (state) => state.fertilizationLegalStandards,
);

export const selectMainCropFields = createSelector(
  selectFertilizationLegalStandards,
  (fertilizationLegalStandards) => fertilizationLegalStandards?.mainCropFields,
);

export const selectSubsequentCultivations = createSelector(
  selectFertilizationLegalStandards,
  (fertilizationLegalStandards) => fertilizationLegalStandards?.subsequentCultivations,
);

export const selectLegalStandardBalance = createSelector(
  selectFertilizationLegalStandards,
  (fertilizationLegalStandards) => fertilizationLegalStandards?.legalStandardBalance,
);

export const selectNManureBalance = createSelector(
  selectLegalStandardBalance,
  (legalStandardBalance) => legalStandardBalance?.nManureBalance,
);

export const selectNTotalBalance = createSelector(
  selectLegalStandardBalance,
  (legalStandardBalance) => legalStandardBalance?.nTotalBalance,
);

export const selectP2O5Balance = createSelector(
  selectLegalStandardBalance,
  (legalStandardBalance) => legalStandardBalance?.p2O5Balance,
);

export const selectFertilizationLegalStandardsReportTitle = createSelector(
  getCropYear,
  UserSelectors.selectCustomer,
  (cropYear: number, customer: Customer, { reportTitle }: { reportTitle: string }) =>
    `${customer?.name ? customer.name : ''} ${reportTitle} ${cropYear}`,
);

export const selectLoggedInEmployee = createSelector(selectLegalStandardState, (state) =>
  state.loggedInEmployee ? [...[state.loggedInEmployee]] : [],
);
